module.exports = __webpack_public_path__ + "img/Card_Shielded_Yellow-min.ba1d909b.png";